import { render, staticRenderFns } from "./StudentTestHistorySubject.vue?vue&type=template&id=691eca32&scoped=true&lang=pug&"
import script from "./StudentTestHistorySubject.vue?vue&type=script&lang=ts&"
export * from "./StudentTestHistorySubject.vue?vue&type=script&lang=ts&"
import style0 from "./StudentTestHistorySubject.vue?vue&type=style&index=0&id=691eca32&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691eca32",
  null
  
)

export default component.exports